export default __webpack_public_path__ + "static/media/shoe09.4596ff7f.jpg";